import { Info } from "lucide-react";

import { useGetWidgetSettings } from "@/api/chat-settings/get-widget-settings";
import { useToggleLeadSettings } from "@/api/chat-settings/lead-status-toggle";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { SwitchSquare } from "@/components/ui/switch-square";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { useAddLeadSettings } from "@/api/chat-settings/add-lead-settings";
import useGlobalPermission from "@/store/user-permissions";

const LeadsCollection = () => {
    const { data: widgetSettings, isLoading } = useGetWidgetSettings();
    const { mutate: toogleLeadCollection, isPending } = useToggleLeadSettings();
    const { mutate: addLeadSettings, isPending: addPending } = useAddLeadSettings();

    const toggleWidgetCollection = (value: boolean) => {
        if (widgetSettings?.data?.lead_collection !== null) {
            toogleLeadCollection({ status: value });
        } else {
            addLeadSettings({
                title: "Stay Connected",
                button_label: "Submit",
                subtitle:
                    "Please provide your email and phone number to receive personalized updates, exclusive offers, and valuable insights tailored to your interests. We respect your privacy and will never share your information without your consent. You can opt out of our communications anytime. For details on how we handle your data, please see our Privacy Policy.",
                marketing_consent_text: "",
                is_collect_phone_number: false,
                is_collect_name: false,
                is_marketing_consent: false,
                status: value,
            });
        }
    };

    const { permissionList } = useGlobalPermission();
    const leadsPermission = permissionList.find((item) => item.module.name === "Leads");

    return (
        <Card className={cn(`h-full border p-6 shadow-none`, !leadsPermission?.can_update && "opacity-50")}>
            {isLoading || isPending || addPending ? (
                <Skeleton className="h-10 w-full" />
            ) : (
                <SwitchSquare
                    disabled={!leadsPermission?.can_update}
                    checked={!!widgetSettings?.data?.lead_collection?.status}
                    onCheckedChange={(value) => toggleWidgetCollection(value)}
                />
            )}
            {isLoading || isPending ? (
                <Skeleton className="mt-2 h-8 w-full" />
            ) : (
                <div className="mt-4 flex items-center gap-2 font-bold text-gray-600">
                    <div className={cn("size-3 rounded-full", widgetSettings?.data?.lead_collection?.status ? "bg-green-500" : "bg-red-500")} /> Leads
                    Collection is {widgetSettings?.data?.lead_collection?.status ? "Enabled" : "disabled"}
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger>
                                <Info className="size-4" />
                            </TooltipTrigger>
                            <TooltipContent>
                                <p>Here is a details on whats going on here</p>
                            </TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                </div>
            )}
            {!leadsPermission?.can_update && <h5 className="text-xs text-red-500">You do not have permission to change this.</h5>}
        </Card>
    );
};

export default LeadsCollection;
